/* eslint-disable @typescript-eslint/naming-convention */

import createSvgIcon from '../Utils/CreateSvgIcon';

export const Equipment = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 6L8.5 4.32994L7.75 2L6.25 2L5.5 4.32994L6 6L6 12H4V14L4 20L4 22H6H8H10V20L10 14V12L8 12L8 6ZM6 14H8L8 20H6L6 14ZM14 7.53973L14 20L16 20L16 7.53973L16.7988 6.9397C17.532 6.38898 18 5.51866 18 4.53846V4L16 4V6H14V4L12 4V4.53846C12 5.51866 12.468 6.38898 13.2012 6.93969L14 7.53973ZM20 2V4.53846C20 6.17428 19.2144 7.62662 18 8.53883L18 22L12 22L12 8.53883C10.7856 7.62662 10 6.17428 10 4.53846V2L20 2Z"
    fill="#303030"
  />,
  'Equipment',
);
